import styles from '../styles/Input.module.css'

function Input({ type = 'text', isValid = 'IDLE', value, onChange, onBlur, id, placeholder, ...rest }) {
  return (
    <input className={isValid === 'ERROR' ? styles.inputError : styles.input} type={type} value={value} onChange={onChange} onBlur={onBlur} id={id} placeholder={placeholder} {...rest} />
  )
}
export default Input